var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"retailers"},[(!_vm.content)?_c('loading'):_c('article',{staticClass:"page__article pd-article",attrs:{"data-aos":"fade-in"},domProps:{"innerHTML":_vm._s(_vm.contentHtml)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }